export const panels = [
  {
    brandName: "Trina",
    moduleName: "Vertex S",
    moduleCategory: "BACKSHEET MONOCRYSTALLINE MODULE",
    name: "TSM-405DE09R.05",
    pMax: 405,
    voc: 49,
    isc: 10.52,
    efficiency: 20.3,
    width: 1.134,
    height: 1.762,
    weight: 21.8,
    tkVoc: -0.25,
    tkIsc: 0.04,
    tkPmax: -0.34,
    tSTC: 25,
  },
  {
    brandName: "Trina",
    moduleName: "Vertex S",
    moduleCategory: "BACKSHEET MONOCRYSTALLINE MODULE",
    name: "TSM-410DE09R.05",
    pMax: 410,
    voc: 49.2,
    isc: 10.58,
    efficiency: 20.5,
    width: 1.134,
    height: 1.762,
    weight: 21.8,
    tkVoc: -0.25,
    tkIsc: 0.04,
    tkPmax: -0.34,
    tSTC: 25,
  },
  {
    brandName: "Trina",
    moduleName: "Vertex S",
    moduleCategory: "BACKSHEET MONOCRYSTALLINE MODULE",
    name: "TSM-415DE09R.05",
    pMax: 415,
    voc: 49.4,
    isc: 10.64,
    efficiency: 20.8,
    width: 1.134,
    height: 1.762,
    weight: 21.8,
    tkVoc: -0.25,
    tkIsc: 0.04,
    tkPmax: -0.34,
    tSTC: 25,
  },
  {
    brandName: "Trina",
    moduleName: "Vertex S",
    moduleCategory: "BACKSHEET MONOCRYSTALLINE MODULE",
    name: "TSM-420DE09R.05",
    pMax: 420,
    voc: 49.7,
    isc: 10.69,
    efficiency: 21,
    width: 1.134,
    height: 1.762,
    weight: 21.8,
    tkVoc: -0.25,
    tkIsc: 0.04,
    tkPmax: -0.34,
    tSTC: 25,
  },
  {
    brandName: "Trina",
    moduleName: "Vertex S",
    moduleCategory: "BACKSHEET MONOCRYSTALLINE MODULE",
    name: "TSM-425DE09R.05",
    pMax: 425,
    voc: 49.9,
    isc: 10.74,
    efficiency: 21.3,
    width: 1.134,
    height: 1.762,
    weight: 21.8,
    tkVoc: -0.25,
    tkIsc: 0.04,
    tkPmax: -0.34,
    tSTC: 25,
  },

  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM460N-60HL4",
    pMax: 460,
    voc: 42.05,
    isc: 13.99,
    efficiency: 21.32,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },
  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM460N-60HL4-V",
    pMax: 460,
    voc: 42.05,
    isc: 13.99,
    efficiency: 21.32,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },

  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM465N-60HL4",
    pMax: 465,
    voc: 42.22,
    isc: 14.07,
    efficiency: 21.55,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },
  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM465N-60HL4-V",
    pMax: 465,
    voc: 42.22,
    isc: 14.07,
    efficiency: 21.55,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },

  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM470N-60HL4",
    pMax: 470,
    voc: 42.38,
    isc: 14.15,
    efficiency: 21.78,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },
  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM470N-60HL4-V",
    pMax: 470,
    voc: 42.38,
    isc: 14.15,
    efficiency: 21.78,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },

  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM475N-60HL4",
    pMax: 475,
    voc: 42.54,
    isc: 14.23,
    efficiency: 22.01,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },
  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM475N-60HL4-V",
    pMax: 475,
    voc: 42.54,
    isc: 14.23,
    efficiency: 22.01,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },

  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM480N-60HL4",
    pMax: 480,
    voc: 42.71,
    isc: 14.31,
    efficiency: 22.24,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },
  {
    brandName: "Jinko",
    moduleName: "Tiger Neo N-type",
    moduleCategory: "MONO-FACIAL MODULE",
    name: "JKM480N-60HL4-V",
    pMax: 480,
    voc: 42.71,
    isc: 14.31,
    efficiency: 22.24,
    width: 1.134,
    height: 1.903,
    weight: 24.2,
    tkVoc: -0.25,
    tkIsc: 0.045,
    tkPmax: -0.29,
    tSTC: 25,
  },
];

export const inverters = [
  {
    name: "SUN2000-5kTL-M1",
    value: 5,
    outPutPower: 5000,
    pvPower: 6000,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 11,
    mscc: 15,
    noOfMPPT: 2,
    noOfStrings: 2,
    acCurrent: 15,
  },
  {
    name: "SUN2000-10kTL-M1",
    value: 10,
    outPutPower: 10000,
    pvPower: 12000,
    efficiency: 98.6,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 11,
    mscc: 15,
    noOfMPPT: 2,
    noOfStrings: 2,
    acCurrent: 15,
  },
  {
    name: "SUN2000-12kTL-M5",
    value: 12,
    outPutPower: 12000,
    pvPower: 14400,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 30,
    mscc: 40,
    noOfMPPT: 2,
    noOfStrings: 4,
    acCurrent: 18.2,
  },
  {
    name: "SUN2000-15kTL-M5",
    value: 15,
    outPutPower: 15000,
    pvPower: 18000,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 30,
    mscc: 40,
    noOfMPPT: 2,
    noOfStrings: 4,
    acCurrent: 25.2,
  },
  {
    name: "SUN2000-17kTL-M5",
    value: 17,
    outPutPower: 17000,
    pvPower: 20400,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 30,
    mscc: 40,
    noOfMPPT: 2,
    noOfStrings: 4,
    acCurrent: 28.6,
  },
  {
    name: "SUN2000-20kTL-M5",
    value: 20,
    outPutPower: 20000,
    pvPower: 24000,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 30,
    mscc: 40,
    noOfMPPT: 2,
    noOfStrings: 4,
    acCurrent: 33.6,
  },
  {
    name: "SUN2000-25kTL-M5",
    value: 25,
    outPutPower: 25000,
    pvPower: 30000,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 980,
    mppt: 30,
    mscc: 40,
    noOfMPPT: 2,
    noOfStrings: 4,
    acCurrent: 42,
  },
  {
    name: "SUN2000-30kTL-M3",
    value: 30,
    outPutPower: 30000,
    pvPower: 36000,
    efficiency: 98.7,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 26,
    mscc: 40,
    noOfMPPT: 4,
    noOfStrings: 8,
    acCurrent: 47.9,
  },
  {
    name: "SUN2000-36kTL-M3",
    value: 36,
    outPutPower: 36000,
    pvPower: 43200,
    efficiency: 98.7,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 26,
    mscc: 40,
    noOfMPPT: 4,
    noOfStrings: 8,
    acCurrent: 58,
  },
  {
    name: "SUN2000-40kTL-M3",
    value: 40,
    outPutPower: 40000,
    pvPower: 48000,
    efficiency: 98.7,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 26,
    mscc: 40,
    noOfMPPT: 4,
    noOfStrings: 8,
    acCurrent: 63.8,
  },
  {
    name: "SUN2000-50kTL-M3",
    value: 50,
    outPutPower: 50000,
    pvPower: 60000,
    efficiency: 98.5,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 20,
    mscc: 40,
    noOfMPPT: 4,
    noOfStrings: 8,
    acCurrent: 79.8,
  },
  {
    name: "SUN2000-100kTL-M2",
    value: 100,
    outPutPower: 100000,
    pvPower: 120000,
    efficiency: 98.8,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 26,
    mscc: 40,
    noOfMPPT: 10,
    noOfStrings: 20,
    acCurrent: 160.4,
  },
  {
    name: "SUN2000-115kTL-M2",
    value: 115,
    outPutPower: 115000,
    pvPower: 138000,
    efficiency: 98.6,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 30,
    mscc: 40,
    noOfMPPT: 10,
    noOfStrings: 20,
    acCurrent: 182.3,
  },
  {
    name: "SUN2000-150kTL-MG0",
    value: 150,
    outPutPower: 150000,
    pvPower: 180000,
    efficiency: 98.4,
    maxInputVolatge: 1100,
    startUpVoltage: 200,
    operatingVoltage: 1000,
    mppt: 48,
    mscc: 66,
    noOfMPPT: 7,
    noOfStrings: 21,
    acCurrent: 253.2,
  },
  {
    name: "SUN2000-330KTL-H1",
    value: 330,
    outPutPower: 330000,
    pvPower: 396000,
    efficiency: 98.8,
    maxInputVolatge: 1500,
    startUpVoltage: 550,
    operatingVoltage: 1500,
    mppt: 28,
    mscc: 115,
    noOfMPPT: 6,
    noOfStrings: 28,
    acCurrent: 238.2,
  },
];

export const DCSwith_Option = [
  {
    label: "KG32 T104/D-P003 KL51V",
    values: {
      isolator: {
        "Rating (A)": "12A",
        "Rating (V)": "1000",
      },
    },
  },
  {
    label: "KGD40 TD103/D-P003 KL11V",
    values: {
      isolator: {
        "Rating (A)": "20A",
        "Rating (V)": "1000",
      },
    },
  },
  {
    label: "KGD40 TD104/D-P003 KL11V",
    values: {
      isolator: {
        "Rating (A)": "30A",
        "Rating (V)": "1000",
      },
    },
  },
  {
    label: "KGD40B TD106/D-P003 KL11V",
    values: {
      isolator: {
        "Rating (A)": "40A",
        "Rating (V)": "1000",
      },
    },
  },
  {
    label: "KGD40B TD108/D-P003 KL11V",
    values: {
      isolator: {
        "Rating (A)": "50A",
        "Rating (V)": "1000",
      },
    },
  },
  { label: "N/A", values: null },
];
